import SurveyConst from "./SurveyConst";
import RequestEntity from "../../api/RequestEntity";
import ApplicationConst from "../../ApplicationConst";
import BaseURL from "../../api/BaseURL";

const BASE_URL = BaseURL.getBaseURL() + "/";
const SurveyActions = {

  setAge:(value) => {
    return {type: SurveyConst.SET_AGE, payload: value}
  },
  setGender:(value) => {
    return {type: SurveyConst.SET_GENDER, payload: value}
  },
  setHasDegree:(value) => {
    return {type: SurveyConst.SET_HAS_DEGREE, payload: value}
  },
  setDegree:(value) => {
    return {type: SurveyConst.SET_DEGREE, payload: value}
  },
  setLanguageNative:(value) => {
    return {type: SurveyConst.SET_LANGUAGE_NATIVE, payload: value}
  },
  setLanguage:(value) => {
    return {type: SurveyConst.SET_LANGUAGE, payload: value}
  },
  setTests:(value) => {
    return {type: SurveyConst.SET_TESTS, payload: value}
  },
  setFeedbackText:(value) => {
    return {type: SurveyConst.SET_FEEDBACK_TEXT, payload: value}
  },
  setSurveyFormValue:(component, value) => {
    return {type: SurveyConst.SET_SURVEY_VALUE, payload: {name: component, value: value}}
  },
  countFormClicks: ()=> {
    return {type: SurveyConst.SURVEY_CLICK}
  },
  saveSurvey:(e) => {
    e.preventDefault();
    return (dispatch, getState) => {
      let clicks = getState().survey.surveyClick.clicked
      let data = getState().survey.data
      let keys = Object.getOwnPropertyNames(data)
      let check = keys.map((key) => data[key] !== "")
      let pass = check.find((c) => c === true)
      if(pass){
        dispatch({type:ApplicationConst.AJAX_CALL, entity: new RequestEntity(BASE_URL + "api/feedback/survey/" + getState().application.token.token, "POST", SurveyConst.SAVE_SURVEY), payload:getState().survey.data})
      }else{
        dispatch({type:SurveyConst.SAVE_SURVEY, payload: {clicked: clicks}})
      }
      return dispatch({type:SurveyConst.TRIGGER_SURVEY_FORM});
    }
  }
};

export default SurveyActions;



// WEBPACK FOOTER //
// ./src/modules/survey/SurveyActions.js